import request from '@/utils/requestUtil'

export function cdkeyList(params) {
  return request({
    url: '/cdkey/my',
    method: 'get',
    params
  })
}

export function cdkeyBind(data) {
  return request({
    url: '/cdkey/bind',
    method: 'post',
    data
  })
}

export function orderPaySuccess(data) {
  return request({
    url: '/order/paySucceed',
    method: 'post',
    data
  })
}

// 下载提货券卡密
export function cdkeyDownload(params) {
  return request({
    url: '/cdkey/down',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

// 总余额
export function cdkeyMyBalance() {
  return request({
    url: '/cdkey/myBalance',
    method: 'get'
  })
}

// 提货券隐藏
export function homeGiftCardOpen() {
  return request({
    url: '/home/giftCardOpen',
    method: 'get'
  })
}
